import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../ts/Glob';
import { IPopupOptions } from '../../ts/actions/DialogActions';
import { IMessage, INotification } from '../../ts/stores/NotificationsStore';
const reactGlobalClick = require('_common/platform/ts/reactGlobalClick');

interface IRemaidersProps
{
    glob: IGlob;
}
interface IRemaindersPanelProps
{
    glob: IGlob;
    options: IRemaindersPopupOptions;
    close(): void;
}

interface IRemaindersPopupOptions extends IPopupOptions
{
    messages: IMessage[];
    docwidth: number;
    docheight: number;
    offsetArrow: number;
    popupPriority?: number;
}

export const Remainders: React.FC<IRemaidersProps> = (props) =>
{

    const [ count, setCount ] = React.useState(0);
    const showPanel = React.useRef<boolean>(false);
    const bellRef = React.useRef<HTMLDivElement>(null);

    const { notifications } = props.glob.NotificationsStore.useSimpleStoreStateHook();
    // test data
    // const notifications = JSON.parse(`[{"id":0,"type":"success","messages":
    //     [ { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:51:53 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //       { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:52:08 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //      { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:52:27 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //      { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:53:00 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //       { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:52:08 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //       { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:52:08 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //      { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:52:27 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //      { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:53:00 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //       { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:52:08 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //      { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:52:27 AM. Perform Reload to get the latest changes from server.", "count": 1 }, 
    //      { "content": "Workspace #3651 has been updated  by Oleg Erjomin at 12/19/2025, 9:53:00 AM. Perform Reload to get the latest changes from server.", "count": 1 } 
    //     ], 
    //       "options": { "manualDestroy": true, "remainder": true }, "timeStamp": 1766127181135}]`);

    React.useEffect(() =>
    {
        const messages = getMessages();
        setCount(messages.length);
    });

    const getMessages = React.useCallback(() =>
    {
        const n = notifications.filter((n) =>
        {
            return n.options.remainder === true;
        });

        const messages = n.reduce((accum: IMessage[], item: INotification) =>
        {
            return accum.concat(item.messages);
        }, []);

        return messages;
    }, [ notifications ]);

    const showRemainders = (e) =>
    {
        if (showPanel.current === true || count === 0) {
            return;
        }

        const messages = getMessages();

        if (messages.length === 0) {
            return;
        }

        const { top, left, width, height } = bellRef.current.getBoundingClientRect();

        const offsetTop = top + height;
        const minWidth = document.documentElement.clientWidth / 3; // Math.min(document.documentElement.clientWidth / 3, 400);
        const offsetArrow = document.documentElement.clientWidth - left;
        const docwidth = minWidth + offsetArrow;
        const docheight = Math.max(document.documentElement.clientHeight, 600);
        //const offsetLeft = document.documentElement.clientWidth - minWidth + (offsetArrow + width / 2);


        showPanel.current = true;

        props.glob.DialogActions.createPopup<IRemaindersPopupOptions>('custom', {
            top: offsetTop,
            //left: offsetLeft,
            docwidth: docwidth,
            docheight: docheight,
            offsetArrow: offsetArrow,
            messages: messages,
            close: () => { showPanel.current = false; },
            component: RemaindersPanel
        });
    };

    return <div className='platform-remainders'>
        <div className='btn border-0' ref={ bellRef } onClick={ showRemainders }>
            {/* <span className='dx-icon dx-icon-belloutline' title='Remainders'></span> */ }
            <span className='fa fa-lg fa-regular fa-bell' title='Remainders'></span>
        </div>
        { count > 0 ? <span className="badge">{ count.toString() }</span> : null }

    </div>;
};

const RemaindersPanel: React.FC<IRemaindersPanelProps> = (props) =>
{

    const arrwoWidth = 6;
    const globalClickIndex = React.useRef(0);
    const popupRef = React.useRef<HTMLDivElement>(null);
    const [ popupWidth, setPopupWidth ] = React.useState<number>(props.options.docwidth);
    const [ messages, setMessages ] = React.useState<IMessage[]>(props.options.messages);
    const bodyHeight = props.options.docheight - props.options.top * 2;

    const markAsRead = (m: IMessage) =>
    {
        const id = m.details?.id;
        if (id != null) {
            props.glob.AppActions.cleanRemainderMessage(id);
            const newMessages = messages.filter((m) =>
            {
                return !(m.details != null && m.details.id != null && m.details.id === id);
            });
            if (newMessages.length === 0) {
                props.close();
            } else {
                setMessages(newMessages);
            }
        }
    };

    const markAllAsRead = () =>
    {
        const messageIds = messages.map(m => m.details?.id);
        messageIds.forEach((id) =>
        {
            props.glob.AppActions.cleanRemainderMessage(id);
        });
        setMessages([]);
        props.close();
    };

    const bodyStyle: React.CSSProperties = {
        overflow: 'auto',
        maxHeight: bodyHeight + 'px',
        display: 'grid',
        gridTemplateColumns: '1rem auto 3rem',
        gap: '10px',
        gridAutoRows: 'minmax(10px, auto)'
    };

    React.useEffect(() =>
    {
        if (props.options.popupPriority != null) {
            globalClickIndex.current = reactGlobalClick.register(props.close, props.options.popupPriority);
        } else {
            globalClickIndex.current = reactGlobalClick.register(props.close, 0);
        }

        return () =>
        {
            reactGlobalClick.unregister(globalClickIndex.current);
            globalClickIndex.current = null;
        };
    }, []);


    React.useEffect(() =>
    {
        setPopupWidth(popupRef.current.clientWidth);
    }, [ popupRef ]);

    return <div className="popover bs-popover-bottom" ref={ popupRef } style={ {
        display: 'block',
        left: (document.documentElement.clientWidth - popupWidth) + 'px',
        top: props.options.top + 'px',
        maxWidth: props.options.docwidth + 'px',
        maxHeight: props.options.docheight + 'px'

    } } >
        <div className="arrow" style={ { left: popupWidth - props.options.offsetArrow + arrwoWidth } }></div>
        <h3 className="popover-header">
            <button type="button" className='btn btn-success' onClick={ () => markAllAsRead() }>{ 'Mark all as read' }</button>
            <button type="button" className="close" onClick={ () => { props.close(); } }>
                ×
            </button>
        </h3>
        <div className="popover-body" style={ bodyStyle }>
            {
                messages.map((m: IMessage, index) =>
                {
                    const cells = [
                        <span className="glyphicon glyphicon-remove"
                            title="Mark as read"
                            onClick={ () => markAsRead(m) }></span>,

                        <span
                            dangerouslySetInnerHTML={ {
                                __html: m.content
                            } }
                        />,
                        <span>
                            { m.reactContent }
                        </span>
                    ];

                    if (index < messages.length - 1) {
                        cells.push(<span style={ { gridColumn: '1/-1', borderBottom: '1px solid lightgrey' } } />);
                    }
                    return cells;

                })
            }
        </div >
    </div >;
};